var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.66667L11.6667 2.5C10.6667 1.83333 9.33333 1.83333 8.33333 2.5L2.5 6.66667C1.83333 7.16667 1.66667 8 1.66667 8.66667V15.8333C1.66667 16.75 2.41667 17.5 3.33333 17.5H16.6667C17.5833 17.5 18.3333 16.75 18.3333 15.8333V8.66667C18.3333 8 18.1667 7.16667 17.5 6.66667ZM10.8333 15.8333H9.16667V11.6667H10.8333V15.8333ZM15.8333 15.8333H12.5V10.8333C12.5 10.4167 12.1667 10 11.6667 10H8.33333C7.83333 10 7.5 10.4167 7.5 10.8333V15.8333H4.16667V8.66667L10 4.16667L15.8333 8.66667V15.8333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.bc406bdc0fd87ead32c52e948dc77c99.svg";
export { ForwardRef as ReactComponent };